import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'

const getMarkerPdfXml = function (marker, ath, atv, useCustomIcon, index, markerScale) {
  let pdf = ''
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    pdf += `<hotspot
    name="marker_${marker.objectId}"
    style="${hotspotIcon(marker, useCustomIcon)}"
    scale="${markerScale}"
    ath="${ath}"
    atv="${atv}"
    alpha="${opacity}"
    zorder="${marker.index}"
    distorted="true"
    inverserotation="${inverserotation}"
    rx="${rx}"
    ry="${ry}"
    rz="${0}"
    mipmapping="true"
    visible="true"
    enabled="${!marker.disabled}"
    capture="false"
    ${generateCustomIconXml(marker)}
    onclick="handle_show_popup(${index});"
    onover="marker_mousein(${marker.objectId}, ${index});"
    onout="marker_mouseout(${marker.objectId}, ${index}, pdf, ${opacity});" />`
  } else {
    pdf += `<hotspot
    name="marker_${marker.objectId}"
    style="${hotspotIcon(marker, useCustomIcon)}"
    scale="${markerScale}"
    ath="${ath}"
    atv="${atv}"
    alpha="${opacity}"
    zorder="${marker.index}"
    visible="true"
    enabled="${!marker.disabled}"
    capture="false"
    ${generateCustomIconXml(marker)}
    onclick="handle_show_popup(${index});"
    onover="marker_mousein(${marker.objectId}, ${index});"
    onout="marker_mouseout(${marker.objectId}, ${index}, pdf, ${opacity});" />`
  }
  pdf += `<hotspot
    name="markerInfo_${marker.objectId}"
    style="markerInfo"
    scale="0"
    visible="false"
    width="0"
    height="0"
    ath="${ath}"
    atv="${atv - 4.5}"
    zorder="${marker.index}" />`
  return pdf
}

export default getMarkerPdfXml
